import { Component, OnInit } from '@angular/core';
import { LabService } from '../lab.service';

@Component({
  selector: 'nw-lab-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss'],
})
export class LabLibraryComponent implements OnInit {
  constructor(private lab: LabService) {}

  async ngOnInit(): Promise<void> {
    const library = await this.lab.getLibrary();
    console.log({ library });
  }
}
